import React from 'react';
import ReferralCriteria from '../Components/ReferralCriteria';

function WithProstateCancer() {
    return ReferralCriteria({
        criteria: [
            (<>Individual with prostate cancer (Gleason score &ge; 7) diagnosed under 50 years</>),
            (<>Individual with prostate cancer diagnosed under 60 years with a first/second degree relative with prostate cancer</>),
            (<>Individual with prostate cancer (Gleason score &ge; 7) with first/second degree relative with breast cancer under 60</>)
        ],
        properties: {
            color: 'blue'
        }
    });
}

export default WithProstateCancer;
